module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('v-layout', {
    attrs: {
      "row": "",
      "wrap": ""
    }
  }, [_c('v-flex', {
    attrs: {
      "xs12": ""
    }
  }, [_c('v-list', [_vm._l((_vm.events), function(event) {
    return [_c('v-list-tile', {
      key: event.id
    }, [_c('v-list-tile-content', [_c('v-list-tile-title', [_vm._v(_vm._s(event.message.text))]), _vm._v(" "), _c('v-list-tile-sub-title', [_vm._v(_vm._s(_vm.eventAuthorName(event)))])], 1), _vm._v(" "), _c('v-list-tile-action', [_vm._v("\n               " + _vm._s(_vm.formatDate(event.timestamp)) + "\n            ")])], 1), _vm._v(" "), _c('v-divider')]
  })], 2), _vm._v(" "), (_vm.events.length === 0) ? _c('v-card', [_c('v-card-text', {
    staticClass: "Aligner",
    staticStyle: {
      "height": "100px"
    }
  }, [_c('v-icon', [_vm._v("not_interested")])], 1)], 1) : _vm._e()], 1)], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-6007acda","hasScoped":true,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/users/UserHistory.vue
// module id = 1197
// module chunks = 1